import {
  FACETS_GROUPS_CONFIG,
  FACETS_GROUPS_CONFIG_SHOP_5157,
  FACETS_GROUPS_CONFIG_TED_7573,
} from 'site-modules/shared/constants/inventory/usurp-filters-config';

export function getGroupsConfig({ isTED7573Eligible, isTED7573Enabled, isShop5157Challenger }) {
  if (isShop5157Challenger) {
    return FACETS_GROUPS_CONFIG_SHOP_5157;
  }

  if (isTED7573Eligible && isTED7573Enabled) {
    return FACETS_GROUPS_CONFIG_TED_7573;
  }

  return FACETS_GROUPS_CONFIG;
}
